import { Box, Chip, Typography } from '@mui/material';
import React from 'react';

export interface ReportRuleFilterChipsProps {
    filterKey: string;
    values: string[];
    maxChips?: number;
}

export const ReportRuleFilterChips: React.FC<ReportRuleFilterChipsProps> = ({ filterKey, values, maxChips }) => {
    const cap = maxChips ?? values.length;
    const shown = values.slice(0, cap);
    const overflow = values.length - cap;
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
            {shown.map((value, chipIdx) => (
                <Chip
                    key={`${filterKey}-${chipIdx}`}
                    size="small"
                    label={<Typography fontSize={12}>{value}</Typography>}
                    sx={{ mr: 0.5, my: 0.25, cursor: 'pointer' }}
                />
            ))}
            {overflow > 0 ? (
                <Typography
                    variant="body2"
                    sx={{ mr: 0.5, my: 0.25, alignSelf: 'center' }}
                >{`+${overflow}`}</Typography>
            ) : null}
        </Box>
    );
};
